import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use multiple timing strategies to ensure scroll happens after render
    const scrollToTop = () => {
      // Scroll window to top
      window.scrollTo(0, 0);

      // Also scroll all elements with overflow-y-auto to top
      const scrollableElements = document.querySelectorAll(
        '[class*="overflow-y-auto"]',
      );
      scrollableElements.forEach((element) => {
        element.scrollTop = 0;
      });

      // Specifically target main element
      const mainElement = document.querySelector("main");
      if (mainElement) {
        mainElement.scrollTop = 0;
      }
    };

    // Immediate scroll
    scrollToTop();

    // Scroll after next render
    requestAnimationFrame(() => {
      scrollToTop();
    });

    // Also scroll with a small delay to catch any async content
    setTimeout(() => {
      scrollToTop();
    }, 0);

    setTimeout(() => {
      scrollToTop();
    }, 100);
  }, [pathname]);

  return null;
}
